<template>
  <Avatar
    :label="label"
    :style="{
      background: bgColor,
      color: 'var(--studio-text)',
      fontWeight: 700,
      fontSize: size + 'px'
    }"
    :size="size === 14 ? 'small' : size <= 20 ? 'small' : 'normal'"
    shape="circle"
  />
</template>

<script>
import { initials } from '../../utils/studio-utils'

export default {
  name: 'StudioAvatar',
  props: {
    name: { type: String, default: '' },
    hue: { type: Number, default: 0 },
    size: { type: Number, default: 20 }
  },
  computed: {
    label() {
      return this.name ? initials(this.name) : '?'
    },
    bgColor() {
      return this.hue ? `oklch(0.93 0.045 ${this.hue})` : 'var(--studio-bg)'
    }
  }
}
</script>
